import React from 'react';
import {
  inject,
  observer
} from 'mobx-react';
import {
  WeaTop,
  WeaTab,
  WeaOrgTree,
  WeaEchart,
  WeaYear,
  WeaDialog,
  WeaPopoverHrm,
  WeaCheckbox,
  WeaRadioGroup,
  WeaRightMenu,
  WeaTools,
  WeaErrorPage,
  WeaAlertPage,
  WeaDatePicker,
  WeaBrowser,
  WeaNewScroll,
  WeaSearchGroup
} from 'ecCom';
import {
  WeaTableNew
} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;
import {
  Modal,
  Row,
  Col,
  Button,
  Spin,
  Icon,
  Calendar,
  Tooltip,
  Timeline
} from 'antd';
import '../style/checking.less';
import '../style/outside.less';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import toString from 'lodash/toString';
import moment from 'moment';
import * as Util from '../util/index';
import Map from '../coms/Map';
import loadjs from 'loadjs';
import {
  i18n
} from '../public/i18n';
import {
  WeaLocaleProvider
} from 'ecCom';
import {
  carousel
} from '../util/index'
const getLabel = WeaLocaleProvider.getLabel;
const toJS = mobx.toJS;

@inject('hrmOutside')

@observer
class main extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.init();
    this.getData();
    //document.title = hrmOutside.title;
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.location.key !== nextProps.location.key) {
      const {
        hrmOutside
      } = this.props;
      hrmOutside.init();
      this.getData();
    }
  }
  getData() {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.getData();
  }
  getRightMenu() {
    const {
      hrmOutside
    } = this.props;
    const {
      dataKey,
      tabkey,
      hasRight
    } = hrmOutside;
    let btns = [];
    if (tabkey == '3' && hasRight) { //分页控件导出有bug，先屏蔽
      btns.push({
        key: "exportExcel",
        icon: <i className='icon-coms-export'/>,
        content: i18n.button.export(),
        onClick: key => {
          hrmOutside.exportExcel(dataKey)
        }
      });
    }

    return btns;
  }
  chooseUser(e) {
    const {
      hrmOutside
    } = this.props;
    let hrmId = '',
      hrmName = undefined;
    if (e.selected) {
      hrmId = e.node.props.id;
      hrmName = e.node.props.name;
    }
    if (hrmId) {
      hrmOutside.updateHrmId(hrmId);
      if (hrmName) hrmOutside.updateHrmName(hrmName);
      this.getData();
    }
  }
  changeUserRoot(ids, names, datas) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.updateUserRoot(datas);
  }
  resetUserRoot() {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.updateUserRoot();
    hrmOutside.updateHrmId();
    hrmOutside.updateHrmName();
    this.getData();
  }
  reFresh() {
    this.getData();
  }
  changeTab(key) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.changeTab(key);
    //this.resetUserRoot();
    this.getData();
  }
  changeDateTab(key) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.changeDateTab(key);
    this.getData();
  }
  changeDate(v1, v2) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.changeDate(v1, v2);
    this.getData();
  }
  handlerCheckbox(v) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.handlerCheckbox(v);
  }
  handlerPosition(item) {
    const {
      hrmOutside
    } = this.props;
    hrmOutside.updatePosition(item);
    hrmOutside.updateVisible(true);
  }
  onTreeCheck(ids, datas) {
    const {
      hrmOutside
    } = this.props;
    let idds = [];
    datas.forEach((d) => {
      idds.push(d.id);
    })
    hrmOutside.updateHrmId(idds.join(','));
    hrmOutside.updateOrgTreeCheckedDatas(datas);
    this.getData();
  }
  renderLeft() {
    const {
      hrmOutside
    } = this.props;
    let {
      leftTitle,
      userRoot,
      orgTreeIsMult,
      orgTreeCheckedDatas
    } = hrmOutside;
    userRoot = toJS(userRoot);
    return <div className="wea-hrm-checking-left" style={{height: window.innerHeight - 125}}>
      <div className="left-header">
        <div className="header-title bb">
          <div style={{padding: '0 15px'}}>
            <span style={{float: 'left'}}>{leftTitle()}</span>
            <span style={{float: 'right', fontSize: '12px'}}>
                <WeaCheckbox onChange={(v)=> {
                    hrmOutside.updateOrgTreeIsMult(v);
                    hrmOutside.updateOrgTreeCheckedDatas();
                    this.refs.orgTree && this.refs.orgTree.resetCheck()
                }}
              value={orgTreeIsMult}/>&nbsp;&nbsp;{getLabel('386504',"开启选择")}
            </span>
          </div>
        </div>
      </div>
      <div className="left-body">
        <div>
            <WeaBrowser isSingle={true}
              linkUrl="/hrm/resource/HrmResource.jsp?id=" title={getLabel('179',"人力资源")} type="1" viewAttr="2"
              replaceDatas={userRoot}
              customIcon="icon-coms-Reset"
              addOnClick={this.resetUserRoot.bind(this)}
              onChange={this.changeUserRoot.bind(this)}
            />
            <div style={{display: orgTreeIsMult == '0'?'block':'none',height: window.innerHeight - 225}}>
              <WeaOrgTree
                renderNodeId = {(item)=> item.id}
                dataUrl="/api/hrm/base/getHrmResourceTree"
                rootKey="rootManager"
                treeNodeClick={this.chooseUser.bind(this)}
                params={Array.isArray(userRoot) && userRoot[0] ? {rootid: userRoot[0].id} : {}}
              />
            </div>
            <div style={{display: orgTreeIsMult == '1'?'block':'none',height: window.innerHeight - 225}}>
              <WeaOrgTree
                ref="orgTree"
                dataUrl="/api/hrm/base/getHrmResourceTree"
                rootKey="rootManager"
                onCheck={this.onTreeCheck.bind(this)}
                isMult={true}
                checkStrictly={false}
                checkedDatas={orgTreeCheckedDatas}
                params={Array.isArray(userRoot) && userRoot[0] ? {rootid: userRoot[0].id} : {}}
              />
            </div>
        </div>
      </div>
    </div>
  }
  renderList() {
    const {
      hrmOutside
    } = this.props;
    let {
      timeData
    } = hrmOutside;
    timeData = toJS(timeData);
    return <Timeline className="list-wrapper grayBG">
      {
        timeData && timeData.map((item,index) => {
          return <Timeline.Item className="list-item">
            <div className="list-item-wrapper">
              <div className="list-item-title">{item.date}</div>
              <div className="list-item-content">
                {
                  isEmpty(item.items) && <div className="no-signinfo gray align-center">
                      <Icon type="frown gray" style={{marginRight : 10}} />
                      {getLabel('386505',"当天无外勤签到记录")}
                    </div>
                }
                {
                  !isEmpty(item.items) && item.items.map(i=> {
                    return <div className="list-item-single">
                      <div className="mb5">
                        {i.name}
                        <span className="gray" style={{marginLeft: 15}}>{i.time}</span>
                        <span style={{float: 'right', marginRight: 10, color: '#67AFF7'}}>{i.signTitle}</span>
                      </div>
                      {i.information && <div className="mb5" dangerouslySetInnerHTML={{__html: i.information}}></div>}
                      {i.pics && <div className="mb5">
                        {
                          i.pics.map(pic=> {
                            return <div>{
                              <img src={pic} border="0" width="100" height="110" onClick={event => carousel(pic,index,'ant-timeline-item')}/>
                            }
                            </div>
                          })
                        }
                        </div>
                      }
                      <span className="cursor-pointer gray"
                          onClick={this.handlerPosition.bind(this, i)}>
                          <i className="icon-coms-position" style={{marginRight: 6}}/> {i.title}</span>
                    </div>
                  })
                }
              </div>
            </div>
          </Timeline.Item>
        })
      }
    </Timeline>
  }
  renderDetail() {
    const {
      hrmOutside
    } = this.props;
    let {
      config,
      dataKey,
      table
    } = hrmOutside;
    // config = toJS(config);
    return <div className="radio-search-group">
     <WeaRadioGroup config={config()} onChange={(params)=> {hrmOutside.radioGroupParams=params;hrmOutside.getData(params)}}/>
     <WeaSearchGroup needTigger={true} title={getLabel('19325',"明细表")} showGroup={true}>
      <WeaTable
        comsWeaTableStore={table}
        hasOrder={true}
        needScroll={true}
        getColumns={columns => this.reRenderColumns(columns,hrmOutside)}
        />
      </WeaSearchGroup>
     </div>
  }
  reRenderColumns = (columns, store) => {
    const {
      handleViewClick
    } = store;

    columns.map(c => {
      if (c.dataIndex === 'canViewSignImg') {
        c.render = function(text, record) {
          const {
            randomFieldId,
            canViewSignImgspan
          } = record;
          if (canViewSignImgspan === '1') {
            return <a onClick={() => handleViewClick(randomFieldId)}>{getLabel(33564,'查看')}</a>
          } else {
            return <span />
          }
        }
      }
    });
  }
  renderMap() {
    const {
      hrmOutside
    } = this.props;
    let {
      mapData
    } = hrmOutside;
    mapData = toJS(mapData);
    if (!isEmpty(mapData)) {
      return <Map config={mapData} mult/>
    } else {
      return <div className="grayBG"><WeaAlertPage
      icon={<img style={{width: 77, height: 97}} src="/cloudstore/resource/pc/com/images/no_sign.png"/>}
      ><div>{getLabel('386505',"当天无外勤签到记录")}</div></WeaAlertPage></div>
    }
  }
  renderContent() {
    const {
      hrmOutside
    } = this.props;
    let {
      tabkey
    } = hrmOutside;
    if (tabkey == 1) return this.renderList();
    if (tabkey == 2) return this.renderMap();
    if (tabkey == 3) return this.renderDetail();
  }

  getTabButtonsAd() {
    const {
      hrmOutside
    } = this.props;
    const {
      dataKey
    } = hrmOutside;
    return [
      (<Button type="primary" onClick={()=>{hrmOutside.exportExcel(dataKey)}}>{i18n.button.export()}</Button>),
    ]
  }

  render() {
    const {
      hrmOutside
    } = this.props;
    let {
      title,
      tabkey,
      tabDatas,
      loading,
      hasRight,
      hrmName,
      dateTabkey,
      dateTabDatas,
      dateTabDatas1,
      pDate,
      showSignInfo,
      signTitle,
      visible,
      positionObj
    } = hrmOutside;
    tabDatas = tabDatas();
    dateTabDatas1 = dateTabDatas1();
    dateTabDatas = dateTabDatas();
    positionObj = toJS(positionObj);
    const errorMsg = getLabel('386507', "你无权查看{params}的外勤数据！").replace('{params}', hrmName);
    return (
      <div className="wea-hrm-checking wea-hrm-outside">
          <WeaPopoverHrm />
          <WeaDialog
            visible={visible}
            onCancel={()=> {hrmOutside.updateVisible(false);}}
            closable
            style={{width: 700, height: 500}}
            title = {getLabel('386506',"位置详情")}
            icon="icon-coms-hrm"
            iconBgcolor='#008572'
          >
            {visible &&<Map config={positionObj} ref="map1"/>}
          </WeaDialog>
          <Spin spining={loading}>
            <WeaRightMenu datas={this.getRightMenu()}>
              <WeaTop
                title={title()}
                icon={<i className='icon-coms-hrm'/>}
                iconBgcolor='#217346'
                buttons={[]}
                buttonSpace={10}
                showDropIcon={true}
                dropMenuDatas={this.getRightMenu()}
              >
                {this.renderLeft()}
                <div style={{width: '100%', paddingLeft: 221}}>
                  <WeaTab
                    buttons={tabkey==3 && this.getTabButtonsAd()}
                    selectedKey={tabkey}
                    keyParam='key'
                    datas={tabDatas}
                    onChange={this.changeTab.bind(this)}
                  />
                  {
                    tabkey!=3 && <Row className="picker-wrapper">
                      {tabkey == 1 && dateTabDatas.map((item)=> {
                        return <Col span={1} onClick={this.changeDateTab.bind(this, item.key)} className={`cursor-pointer date-item ${item.key===dateTabkey?'active':'' }`}>
                          {item.title}
                         </Col>
                        }
                      )}
                      {tabkey == 2 && dateTabDatas1.map((item)=> {
                        return <Col span={1} onClick={this.changeDateTab.bind(this, item.key)} className={`cursor-pointer date-item ${item.key===dateTabkey?'active':'' }`}>
                          {item.title}
                         </Col>
                        }
                      )}
                      <Col span={13} className="picker">
                        <WeaDatePicker arrow type={dateTabkey == '3' ? 'month': 'day'} date={pDate} onChange={this.changeDate.bind(this)}/>
                        <i className="icon-coms-Refresh cursor-pointer outside-refresh" onClick={this.reFresh.bind(this)}/>
                      </Col>
                      <Col span={6} className ="checkbox-wrapper" title={signTitle()}>
                        <WeaCheckbox value={showSignInfo} onChange={this.handlerCheckbox.bind(this)}/>
                        {signTitle()}
                      </Col>
                    </Row>
                  }
                  <WeaNewScroll height={tabkey==3? window.innerHeight - 150 - 35 : window.innerHeight - 150 - 65}>
                    <div className={`${tabkey == 2 ? 'wea-outside-content': ''}`}>
                      {!hasRight && <WeaAlertPage>
                        <div>{errorMsg}</div>
                      </WeaAlertPage>}
                      {hasRight && this.renderContent()}
                    </div>
                  </WeaNewScroll>
                </div>
              </WeaTop>
            </WeaRightMenu>
          </Spin>
        </div>
    )
  }
}

export default main


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/Outside.js